import { Component, Input, OnChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ColTypeEnum } from '../../enums/schema-builder-types.enum';
import { SchemaBuilderColumnCustomization, SchemaBuilderTableData } from '../../interfaces/schema-builder.interface';

@Component({
  selector: 'cargoes-schema-builder-table',
  templateUrl: './schema-builder-table.component.html',
  styleUrls: ['./schema-builder-table.component.less'],
})
export class SchemaBuilderTableComponent implements OnChanges {
  @Input() showPagination = true;
  @Input() tableData!: SchemaBuilderTableData;
  @Input() type!: string;
  @Input() loading!: boolean;
  @Input() showCheckBox!: boolean;
  public colTypeEnum = ColTypeEnum;
  public initialColumnWidth = '200px';
  constructor(private sanitizer: DomSanitizer) {}
  ngOnChanges(): void {
    this.tableData.data = [...this.tableData.data];
  }
  appendHtml(html: any) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
  getCustomizeCol(customizedColKey: string): any {
    if (
      typeof this.tableData.customizedCol === 'undefined' ||
      this.tableData?.customizedCol.length === 0
    ) {
      return false;
    }
    return this.tableData?.customizedCol?.find(
      (data: SchemaBuilderColumnCustomization) => {
        return data.key === customizedColKey;
      }
    );
  }
  showHide(data: any, customizedColKey: any) {
    const col = this.getCustomizeCol(customizedColKey);
    return col?.showHide
      ? col?.showHide?.option === 'hide'
        ? data[col?.showHide?.key] !== col?.showHide?.value
        : data[col?.showHide?.key] === col?.showHide?.value
      : true;
  }
  getToolTipTitle(data: any, customizedColKey: string): string {
    const toolTipKey = this.getCustomizeCol(customizedColKey)?.icon?.toolTipKey;
    return data[toolTipKey] || '';
  }

  getIcon(index:number,customizedColKey: string): string {
    let icon = this.getCustomizeCol(customizedColKey)?.icon?.nzType;
    if(icon == undefined){
      icon = this.getCustomizeCol(customizedColKey)?.icon?.nzTypeHandler(index);
    }
    return icon;
  }
}
